export default {
      id: "common__status_tracking-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__status_tracking",
      toString: function () {
        return this.url;
      }
    }